/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown>, name: NonNullable<unknown> }} Drastic_Tech_File_Imported_LogInputs */



/**
* | output |
* | --- |
* | "{format} file imported into {name} event group." |
*
* @param {Drastic_Tech_File_Imported_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_file_imported_log = /** @type {((inputs: Drastic_Tech_File_Imported_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_File_Imported_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Fichier ${i?.format} importe dans le groupe d'evenements ${i?.name}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Datei ${i?.format} wurde in die Ereignisgruppe ${i?.name} importiert.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`File ${i?.format} importato nel gruppo di eventi ${i?.name}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Файл ${i?.format} импортирован в группу событий ${i?.name}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Archivo ${i?.format} importado al grupo de eventos ${i?.name}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`将 ${i?.format} 文件导入到 ${i?.name} 事件组中。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.format} ファイルが ${i?.name} イベント グループにインポートされました。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.format} फ़ाइल को ${i?.name} इवेंट समूह में आयात किया गया।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O arquivo ${i?.format} foi importado para o grupo de eventos ${i?.name}.`)
	return /** @type {LocalizedString} */ (`${i?.format} file imported into ${i?.name} event group.`)
});